module.exports = __webpack_public_path__ + "static/rp-hov2-5d23cee6ad0d85bd3cbc14f4b66cf882.png";